import { http } from '../fetch.js';
//toc booking
export const address_book = {
  create_new_address (postData) {
    return new Promise((resolve, reject) => {
      http.post(
        '/app/interface/AddressBook/add_student_addressbook',
        postData
      ).then(result => {
        if (result) {
          if (result.errcode != 200 && result.errcode != 1007
            && result.errcode != 1008) {
            reject(result.errmsg);
          } else {
            resolve(result.data);
          }
        }
      }).catch(function (error) {
        let errmsg = error.message || error.msg || error;
        reject(errmsg);
      });
    });
  },
  fetch_address_details (postData) {
    return new Promise((resolve, reject) => {
      http.post(
        '/app/interface/AddressBook/get_student_addressbook',
        postData
      ).then(result => {
        if (result) {
          if (result.errcode != 200 && result.errcode != 1007
            && result.errcode != 1008) {
            reject(result.errmsg);
          } else {
            resolve(result.data);
          }
        }
      }).catch(function (error) {
        let errmsg = error.message || error.msg || error;
        reject(errmsg);
      });
    });
  },
  edit_address_details (postData) {
    return new Promise((resolve, reject) => {
      http.post(
        '/app/interface/AddressBook/edit_student_addressbook',
        postData
      ).then(result => {
        if (result) {
          if (result.errcode != 200 && result.errcode != 1007
            && result.errcode != 1008) {
            reject(result.errmsg);
          } else {
            resolve(result.data);
          }
        }
      }).catch(function (error) {
        let errmsg = error.message || error.msg || error;
        reject(errmsg);
      });
    });
  },
  delete_address (postData) {
    return new Promise((resolve, reject) => {
      http.post(
        '/app/interface/AddressBook/delete_student_addressbook',
        postData
      ).then(result => {
        if (result) {
          if (result.errcode != 200 && result.errcode != 1007
            && result.errcode != 1008) {
            reject(result.errmsg);
          } else {
            resolve(result.data);
          }
        }
      }).catch(function (error) {
        let errmsg = error.message || error.msg || error;
        reject(errmsg);
      });
    });
  }
};